import { useContext } from 'react'

import { TaggingContext } from './TaggingProvider'

export const useTagging = () => {
  const context = useContext(TaggingContext)

  if (!context) {
    throw new Error('useTagging must be used within a TaggingProvider')
  }

  return context
}
